import { axiosInstance } from "../network";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  createBusinessDetails: (data) => {
    return axiosInstance.post(API_URL.BUSINESS_CREATE, data);
  },

  createSubscription: (data) => {
    return axiosInstance.post(API_URL.CREATE_SUBSCRIPTION, data);
  },

  cancelSubscription: (id) => {
    return axiosInstance.post(`${API_URL.CANCEL_SUBSCRIPTION}/${id}`, {});
  },

  paymentVerification: (data) => {
    return axiosInstance.post(API_URL.PAYMENT_VERIFY, data);
  },
  deleteSubscribe: (id, data) => {
    return axiosInstance.post(`${API_URL.DELETE_SUBSCRIPTION}/${id}`, data);
  },

  fileUpload: (data) => {
    return axiosInstance.post(API_URL.FILE_UPLOAD, data, {
      headers: {
        "Content-Type": "application/form-data",
        Authorization: "allow",
        isAuthRequired: true,
      },
    });
  },

  updateBusinessdetails: (proid, id, bid, data) => {
    return axiosInstance.put(
      `${API_URL.PUT_BUSINESSDETAILS}/${proid}/${bid}/${id}`,
      data
    );
  },

  getPlanFeatures: (id) => {
    return axiosInstance.get(`${API_URL.PLAN_FEATURES}/${id}`);
  },

  getInvoice: (id) => {
    return axiosInstance.get(`${API_URL.INVOICE_PDF}/${id}`, {
      responseType: "blob",
    });
  },

  findSubscriptions: (id) => {
    return axiosInstance.get(`${API_URL.FIND_SUBSCRIPTION}/${id}`);
  },

  getAllSubscriptionById: (id, page, pageSize, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axiosInstance.get(`${API_URL.SUBCRIPTIONBYID}/${id}`, {
      params: {
        product_uuid: filteredParams.product,
        date_filter_by: filteredParams.filterBy,
        from: filteredParams.fromDate,
        to: filteredParams.toDate,
        subscription_status: filteredParams.status,
        page,
        pageSize,
      },
    });
  },

  getAllSubscriptionByFilterId: (id) => {
    return axiosInstance.get(`${API_URL.SUBCRIPTIONBYID}/${id}`);
  },
};
